<template>
  <b-form-group :label="field.label" :label-for="`${field.key}Input`" :description="field.description">

    <b-form-checkbox v-model="useDefault">
      Use default value
    </b-form-checkbox>

    <b-form-textarea v-if="type === 'LIST'" :id="`${field.key}Input`" rows="2" no-resize
      :disabled="useDefault" :required="!useDefault" v-model="contents"/>

    <b-form-input v-else-if="type === 'URL'" :id="`${field.key}Input`" type="url"
      :disabled="useDefault" :required="!useDefault" v-model="contents"/>

    <markdown-editor v-else-if="field.markdown" :configs="markdownConfig" v-model="contents"/>

    <b-form-textarea v-else-if="field.multiline" :id="`${field.key}Input`" rows="2" no-resize
      :disabled="useDefault" :required="!useDefault" v-model="contents"/>

    <b-form-input v-else :id="`${field.key}Input`"
      :disabled="useDefault" :required="!useDefault" v-model="contents"/>

    <b-form-text v-if="field.tokens">
      <strong>Variables you can use:</strong>
      <span v-for="(description, token) in field.tokens" :key="`${field.key}-${token}`" class="d-flex flex-row align-items-start">
        <pre class="d-inline m-0 pr-1">{{tokenVar(token)}}</pre> - {{ description }}
      </span>
    </b-form-text>

  </b-form-group>
</template>

<script>
import { markdownEditor } from 'vue-simplemde';

export default {
  props: {
    field: Object,
    value: Object,
  },
  components: {
    markdownEditor,
  },
  data() {
    return {
      contents: null,
      useDefault: this.value ? this.value.default : true
    };
  },
  created() {
    this.contents = this.getContents();
  },
  computed: {
    type() {
      return this.value ? this.value.type : null;
    },
    markdownConfig: () => ({
      forceSync: true,
      indentWithTabs: false,
      renderingConfig: { codeSyntaxHighlighting: false },
      promptURLs: true,
      spellChecker: false,
      status: false,
      toolbar: [ 'bold', 'italic', 'strikethrough', '|', 'unordered-list', 'link', 'image', 'preview', 'horizontal-rule' ],
    }),
  },
  methods: {
    getContents() {
      if (this.type === 'LIST') {
        const contents = this.value.value || this.value.placeholder;
        return JSON.parse(contents).join('\n');
      } else {
        return this.value.value || this.value.placeholder;
      }
    },
    tokenVar(token) {
      return `{{${token}}}`;
    },
  },
  watch: {
    useDefault(check) {
      if (check === true) {
        this.$emit('input', Object.assign(this.value, { value: null }));
        this.contents = this.getContents();
      }
    },
    contents(value) {
      if (this.useDefault) {
        this.$emit('input', Object.assign(this.value, { value: null }));
      } else if (this.type === 'LIST') {
        this.$emit('input', Object.assign(this.value, { value: JSON.stringify(value.split('\n')) }));
      } else {
        this.$emit('input', Object.assign(this.value, { value }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/TemplateBlock.vue